import React from 'react';
import BottomSheetModal from './BottomSheetModal';

interface MobileBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  maxHeight?: string;
  children: React.ReactNode;
}

/**
 * Generic mobile-only bottom sheet wrapper component
 * Wraps BottomSheetModal with lg:hidden to only show on mobile devices
 * Can be reused for any content that needs a mobile bottom sheet
 */
const MobileBottomSheet: React.FC<MobileBottomSheetProps> = ({
  isOpen,
  onClose,
  title,
  maxHeight = 'max-h-[85vh]',
  children,
}) => {
  return (
    <div className="lg:hidden">
      <BottomSheetModal
        isOpen={isOpen}
        onClose={onClose}
        title={title}
        maxHeight={maxHeight}
      >
        {children}
      </BottomSheetModal>
    </div>
  );
};

export default MobileBottomSheet;
